/* CNY Slides Builder (Option A)
   - Uses SLB_STD_EDITOR_V1 for toolbar + rich area
   - Stores draft slides in localStorage
   - Exports JSON: [{title, bodyHtml}]
*/
(function(){
  var KEY = 'TY_CNY_SLIDES_DRAFT_V1';
  // Non-blocking toast (Phase 7 polish)
  function toastCny(type, msg){
    try{
      var id = 'cnyToast';
      var el = document.getElementById(id);
      if(!el){
        el = document.createElement('div');
        el.id = id;
        el.style.cssText = 'position:fixed;left:50%;bottom:18px;transform:translateX(-50%);padding:10px 14px;border-radius:12px;box-shadow:0 10px 24px rgba(0,0,0,.18);font-weight:900;font-size:13px;z-index:9999;opacity:0;transition:opacity .15s ease;pointer-events:none;max-width:92vw;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;';
        document.body.appendChild(el);
      }
      var bg = (type==='ok') ? '#2f8f3a' : (type==='warn') ? '#b36b00' : '#a60000';
      el.style.background = bg;
      el.style.color = '#ffffff';
      el.textContent = String(msg||'');
      el.style.opacity = '1';
      if(el.__t) clearTimeout(el.__t);
      el.__t = setTimeout(function(){ el.style.opacity = '0'; }, 2200);
    }catch(_e){}
  }
  function okCny(m){ toastCny('ok', m); }
  function errCny(m){ toastCny('err', m); }


  function $(sel, root){ return (root||document).querySelector(sel); }
  function $all(sel, root){ return Array.prototype.slice.call((root||document).querySelectorAll(sel)); }

  function getArea(){ return document.getElementById('cnyB_body'); }
  function getTitleInp(){ return document.getElementById('cnyB_title'); }
  function getSelect(){ return document.getElementById('cnyB_slideSelect'); }
  function getJsonBox(){ return document.getElementById('cnyB_json'); }

  function safeHtml(html){
    var s = String(html||'');
    // strip scripts
    s = s.replace(/<\s*script[^>]*>[\s\S]*?<\s*\/\s*script\s*>/gi,'');
    // strip on* attributes
    s = s.replace(/\son\w+\s*=\s*(["']).*?\1/gi,'');
    return s;
  }
  function enforceImportantStyles(html){
    var s = String(html||'');
    // Add !important to inline color/background-color so theme CSS can't override it.
    // Only touches style="" attributes.
    s = s.replace(/style=(["'])([^"']*)\1/gi, function(m,q,styles){
      var out = styles;
      // normalize
      out = out.replace(/\s+/g,' ').trim();
      // add !important to color and background-color and text-decoration
      out = out.replace(/\b(color\s*:\s*[^;!]+)(?!\s*!important)\s*;?/gi, function(_,decl){ return decl.trim()+' !important;'; });
      out = out.replace(/\b(background-color\s*:\s*[^;!]+)(?!\s*!important)\s*;?/gi, function(_,decl){ return decl.trim()+' !important;'; });
      out = out.replace(/\b(text-decoration\s*:\s*[^;!]+)(?!\s*!important)\s*;?/gi, function(_,decl){ return decl.trim()+' !important;'; });
      return 'style=' + q + out + q;
    });
    // Ensure links are clickable and open new tab by default (safe for public guide)
    s = s.replace(/<a\s+([^>]*?)>/gi, function(m,attrs){
      var a = attrs;
      if(!/\btarget=\s*["']?_blank["']?/i.test(a)) a += ' target="_blank"';
      if(!/\brel=\s*["'][^"']*["']/i.test(a)) a += ' rel="noopener noreferrer"';
      else if(!/noopener/i.test(a) || !/noreferrer/i.test(a)) a = a.replace(/\brel=(["'])([^"']*)\1/i, function(_,q,v){
        var vv=v;
        if(!/noopener/i.test(vv)) vv += ' noopener';
        if(!/noreferrer/i.test(vv)) vv += ' noreferrer';
        return 'rel=' + q + vv.trim() + q;
      });
      return '<a ' + a + '>';
    });
    return s;
  }


  function loadDraft(){
    try{
      var raw = localStorage.getItem(KEY) || '';
      if(!raw.trim()) return null;
      var data = JSON.parse(raw);
      if(Array.isArray(data)) return data;
    }catch(e){}
    return null;
  }

  function saveDraft(slides){
    try{ localStorage.setItem(KEY, JSON.stringify(slides||[])); }catch(e){}
  }

  function defaultSlides(){
    // a helpful starter set (user can edit)
    return [
      { title: "Chinese New Year (CNY) Guide", bodyHtml: "<p>This is a quick public guide — simple steps, correct sequence. Swipe through the chapters.</p>" },
      { title: "Quick Start (Minimum Version)", bodyHtml: "<p>If you are busy, do the minimum version:</p><ol><li>Conclude and thank (3 minutes)</li><li>Clean the container (one solid cleaning + loud wind walk)</li><li>Do website worship during Day 1–9</li><li>Check Fan Tai Sui and protect if needed</li></ol>" },
      { title: "Chapter 1 — CNY is a full reset", bodyHtml: "<p>CNY is a reset system, not one dinner night. Use this window to clear old mess and welcome new luck with less interference.</p>" },
      { title: "Chapter 2 — The 3 phases", bodyHtml: "<p>Phase A (24–26): conclude + thank. Phase B (27–29): clean + clear. Phase C (Day 1–9, Day 15): build the new year.</p>" },
      { title: "Chapter 3 — Conclude properly (24–26)", bodyHtml: "<p>Close loops. End clean. Write: what you finished, what you learned, what you drop, who you thank, what you want next.</p>" },
      { title: "Chapter 4 — Cleaning that changes luck (27–29)", bodyHtml: "<p>Clean the home. Throw away broken junk. Then do a loud clearing walk to stir and guide stagnant Chi out of the home.</p>" },
      { title: "Chapter 5 — Banners are routing", bodyHtml: "<p>Banners are not decoration. They route the year’s focus. Keep the words short and clear.</p>" },
      { title: "Chapter 6 — Food as a blessing vessel", bodyHtml: "<p>Offer what you can eat. Clean plate, clean intention. After offering, consuming it helps store the blessing.</p>" },
      { title: "Chapter 7 — Greetings with direction", bodyHtml: "<p>Don’t only repeat one phrase. Add direction: health, peace, stable money flow, protection, harmony.</p>" },
      { title: "Chapter 8 — Taboos (keep the connection clean)", bodyHtml: "<p>Avoid unnecessary cutting and chaos during the key window. Keep the container stable so the new flow can settle.</p>" },
      { title: "Chapter 9 — Day 1–9 build", bodyHtml: "<p>Connect first, then receive, then build, then lock it in. If you miss a day, continue — consistency wins.</p>" },
      { title: "Chapter 10 — Fan Tai Sui + Final Actions", bodyHtml: "<p>Check your Fan Tai Sui status, protect the correct pillar if needed, then do the 4 actions:</p><ol><li>Website worship</li><li>Luck Boost FU</li><li>Fan Tai Sui Protection FU (if needed)</li><li>Optional: ordain for stronger foundation</li></ol>" }
    ];
  }

  
  function fullDefaultSlides(){
    // Full guide starter set (narrative). You can edit after loading.
    return [{"title": "Chinese New Year (CNY) Guide — Public Version", "bodyHtml": "<p>This is a beginner-friendly guide for people who want a cleaner start, smoother luck flow, and stronger protection for the new year.</p><p>Do what you can. Chinese New Year is not meant to stress you out — it is meant to help you reset your life container and start clean.</p><p><b>How to use this:</b> Swipe left/right on mobile. On desktop, use your mouse wheel over the slides, or click Next/Prev. You can also switch to “Read as article”.</p>"}, {"title": "Quick Start (Minimum Version — 10 minutes)", "bodyHtml": "<p>If you are busy and you only do the minimum, do these four steps. This covers the core logic of the whole guide:</p><ol><li><b>Close the old year:</b> 3 minutes to conclude and thank (Chapter 3).</li><li><b>Clean the container:</b> one solid home clean + a loud “wind walk” (Chapter 4).</li><li><b>Connect:</b> do one simple worship via our website during Day 1–9 (Chapter 9).</li><li><b>Protect:</b> check Fan Tai Sui, then use the right protection (Chapter 10).</li></ol><p>If you have time to do more, follow the chapters in order. This guide is designed so you can do it step by step without guessing.</p>"}, {"title": "Chapter 1 — CNY is a full reset, not one dinner night", "bodyHtml": "<p>Many people treat Chinese New Year like one dinner night, one greeting, and that’s it. In our tradition, it is a full reset system.</p><p>Why does it matter? Because your life carries leftover mess from the previous year — mentally, physically, and spiritually. Even if the year was good, you still carry stress, unfinished tasks, and old energy that clings to your home and body.</p><p>Simple analogy: your phone still works without rebooting. But rebooting often clears things up and runs smoother. CNY works the same way.</p>"}, {"title": "Chapter 2 — The timeline: 3 phases that make CNY work", "bodyHtml": "<p>To make CNY work, you need a timeline. Without it, people do the right thing on the wrong day. Here is the simple map:</p><p><b>Phase A (Lunar 24–26):</b> Conclude and thank. Close loops and reduce chaos.</p><p><b>Phase B (Lunar 27–29):</b> Clean up and clear. Wash the luck container.</p><p><b>Phase C (Day 1–9, and Day 15):</b> Build the new year flow. Day 15 is clean closure and thanks.</p>"}, {"title": "Chapter 3 — Phase A: Conclude the old year properly (Lunar 24–26)", "bodyHtml": "<p>Most people skip the conclusion phase and jump straight to food and gatherings. That’s why the new year feels the same as the old year.</p><p>Core idea: unfinished things create energetic hooks. Those hooks keep pulling your attention and luck back into the old year. When you conclude, you cut those hooks gently and cleanly.</p><p><b>Simple 5‑minute method:</b></p><ul><li>Write 3 things you finished (small wins count).</li><li>Write 3 lessons you learned.</li><li>Write 3 things you will stop carrying into next year.</li><li>Write 3 people you sincerely thank.</li><li>Write one clear sentence for next year (example: “steady money flow and calm mind”).</li></ul>"}, {"title": "Chapter 4 — Phase B: Cleaning that actually changes your luck (Lunar 27–29)", "bodyHtml": "<p>Your home is your main luck container. If the home is messy, stagnant, and heavy, luck can still come — but it won’t stick well.</p><p><b>Step 1:</b> Physical cleaning. Focus on entrance area, living room, kitchen, and your sleeping space. Throw away broken items and old junk. Clean corners.</p><p><b>Step 2:</b> The “wind walk”. After cleaning, create loud sound (clap, pot/pan, safe tapping) to stir stagnant energy, then guide it out. Start from the back and move toward the entrance.</p><p><b>Step 3:</b> Keep the container stable after Lunar 29. Reduce unnecessary chaos so the reset can settle.</p>"}, {"title": "Chapter 5 — CNY prep: Banners are routing, not decoration", "bodyHtml": "<p>Banners are a routing tool. They create direction for what you want the year to receive. Clear words carry clear direction.</p><p>Keep banner words simple and specific. Don’t write ten things. Write a few strong lines your family agrees with.</p><p><b>Practical tips:</b></p><ul><li>Short and clear is better than poetic but vague.</li><li>If your home has limited space, one strong banner line is enough.</li><li>Put banners up after cleaning so the routing is placed into a clean container.</li></ul>"}, {"title": "Chapter 6 — CNY prep: Food, sweets, and blessing vessels", "bodyHtml": "<p>Food is not just food during CNY. When you offer food with proper respect, it becomes a blessing vessel — it carries a message and a connection.</p><p>After offering, when you and your family eat it, it becomes a way to store the blessing into your life. This is why CNY sweets matter: sweet means smooth, pleasant, and supportive.</p><p><b>Keep it simple:</b> Offer what you can actually eat (fruits, tea, snacks). Clean plate, clean intention, simple respect.</p>"}, {"title": "Chapter 7 — Greetings that actually do something", "bodyHtml": "<p>Many greetings are empty because they have no direction. A greeting is like sending energy. If you send it with a clear direction, it becomes stronger.</p><p>Instead of repeating one phrase only, add a direction after it. Example: “Wishing you a smooth year and steady progress.”</p><p><b>Easy templates:</b> strong health and peaceful home • calm mind and good support • stable money flow • protection and fewer troubles • family harmony and good news often.</p>"}, {"title": "Chapter 8 — Taboos: what to avoid, and why", "bodyHtml": "<p>Taboos exist for a reason. The goal of the reset window is to connect and load the new year flow. Actions that cut, scatter, or destabilize reduce the quality of that connection.</p><p>Simple rule: do your “cutting” actions before the key window when possible (haircut, nails, big rearranging). During the key days, keep things stable and clean.</p><p>Also: avoid turning the reset into drama. Drama is a luck leak.</p>"}, {"title": "Chapter 9 — Day 1 to Day 9: the nine-day build", "bodyHtml": "<p>Day 1–9 is the main run. Think of it like building a base layer: connect first, then receive, then build, then lock it in. You do not need complex rituals. You need sequence.</p><p><b>Simple daily meaning:</b></p><ul><li>Day 1: open and connect.</li><li>Day 2: submit your request (be clear).</li><li>Day 3–4: prepare and receive (keep the home clean).</li><li>Day 5: lock in (reduce chaos, let it settle).</li><li>Day 6–7: build Chi → manifest (take real actions).</li><li>Day 8: grow (strengthen the path).</li><li>Day 9: confirm and conclude.</li></ul><p><b>Where website worship fits:</b> beginners can connect through our website worship during Day 1–9. Even if you do only one thing, do this step.</p>"}, {"title": "Chapter 10 — Fan Tai Sui + what to do next", "bodyHtml": "<p>Fan Tai Sui is a type of interference. In simple words: your connection becomes weaker or distorted because of positioning. When the connection is unstable, life can feel harder than normal — more obstacles, delays, and unexpected trouble.</p><p>Fan Tai Sui can hit different pillars (year, month, day, time). If more pillars are affected, it becomes more serious. That’s why you should check your situation instead of guessing.</p><p><b>Your action steps (the 4 goals):</b></p><ol><li><b>Worship via our website</b> (basic connection).</li><li><b>Get a Luck Boost FU</b> (build and hold better luck flow).</li><li><b>If you are Fan Tai Sui:</b> get the Fan Tai Sui Protection FU (pillar-specific protection).</li><li><b>Optional:</b> ordain for stronger long-term protection and a better luck foundation.</li></ol>"}];
  }

function rebuildSelect(slides, sel, currentIndex){
    sel.innerHTML = '';
    slides.forEach(function(s, i){
      var opt = document.createElement('option');
      opt.value = String(i);
      opt.textContent = (i+1) + ". " + (s.title || ("Slide " + (i+1)));
      sel.appendChild(opt);
    });
    sel.value = String(currentIndex||0);
  }

  function renderSlide(slides, idx){
    idx = Math.max(0, Math.min(slides.length-1, idx|0));
    var t = slides[idx] || {title:'', bodyHtml:''};
    getTitleInp().value = t.title || '';
    var area = getArea();
    if(area) area.innerHTML = t.bodyHtml || '';
    return idx;
  }

  function getCurrent(slides, idx){
    var t = getTitleInp().value || '';
    var area = getArea();
    var b = area ? area.innerHTML : '';
    slides[idx] = { title: String(t), bodyHtml: enforceImportantStyles(safeHtml(b)) };
  }

  function exportJson(slides){
    var clean = (slides||[]).map(function(s){
      return { title: String((s&&s.title)||''), bodyHtml: safeHtml((s&&s.bodyHtml)||'') };
    });
    return JSON.stringify(clean, null, 2);
  }

  function copyToClipboard(text){
    try{
      navigator.clipboard.writeText(text);
      return true;
    }catch(e){
      // fallback
      var ta = getJsonBox();
      ta.focus(); ta.select();
      try{ document.execCommand('copy'); return true; }catch(e2){}
    }
    return false;
  }

  function init(){
    var root = document.querySelector('[data-cny-builder-root]');
    if(!root) return;

    // ensure editor binds
    function bindEditor(){
      if(window.SLB_STD_EDITOR_V1 && window.SLB_STD_EDITOR_V1.autoBind){
        window.SLB_STD_EDITOR_V1.autoBind();
      }
    }
    // in case deferred load
    setTimeout(bindEditor, 30);
    setTimeout(bindEditor, 250);
    setTimeout(bindEditor, 800);

    var slides = loadDraft() || defaultSlides();
    var idx = 0;

    var sel = getSelect();
    rebuildSelect(slides, sel, idx);
    idx = renderSlide(slides, idx);
    saveDraft(slides);

    sel.addEventListener('change', function(){
      getCurrent(slides, idx);
      idx = parseInt(sel.value, 10) || 0;
      idx = renderSlide(slides, idx);
      saveDraft(slides);
    });

    document.getElementById('cnyB_save').addEventListener('click', function(){
      getCurrent(slides, idx);
      rebuildSelect(slides, sel, idx);
      saveDraft(slides);
      okCny('Saved');
    });

    document.getElementById('cnyB_new').addEventListener('click', function(){
      getCurrent(slides, idx);
      slides.push({ title: "New Slide", bodyHtml: "<p></p>" });
      idx = slides.length - 1;
      rebuildSelect(slides, sel, idx);
      idx = renderSlide(slides, idx);
      saveDraft(slides);
    });

    document.getElementById('cnyB_del').addEventListener('click', function(){
      if(slides.length<=1){ errCny('Need at least 1 slide'); return; }
      slides.splice(idx, 1);
      idx = Math.max(0, Math.min(slides.length-1, idx));
      rebuildSelect(slides, sel, idx);
      idx = renderSlide(slides, idx);
      saveDraft(slides);
    });

    document.getElementById('cnyB_export').addEventListener('click', function(){
      getCurrent(slides, idx);
      var out = exportJson(slides);
      getJsonBox().value = out;
      saveDraft(slides);
    });

    document.getElementById('cnyB_copy').addEventListener('click', function(){
      var txt = getJsonBox().value || exportJson(slides);
      getJsonBox().value = txt;
      var ok = copyToClipboard(txt);
      (ok ? okCny('Copied') : errCny('Copy failed — copy manually.'));
    });

    var importWrap = document.getElementById('cnyB_importWrap');
    var importBox = document.getElementById('cnyB_import');

    document.getElementById('cnyB_importBtn').addEventListener('click', function(){
      if(importWrap.classList.contains('hidden')){
        importWrap.classList.remove('hidden');
        importBox.focus();
        return;
      }
      // do import
      try{
        var raw = importBox.value || '';
        var data = JSON.parse(raw);
        if(!Array.isArray(data) || !data.length) throw new Error('Invalid JSON');
        slides = data.map(function(s){
          return { title: String((s&&s.title)||''), bodyHtml: safeHtml((s&&s.bodyHtml||s.body)||'') };
        });
        idx = 0;
        rebuildSelect(slides, sel, idx);
        idx = renderSlide(slides, idx);
        saveDraft(slides);
        importWrap.classList.add('hidden');
        importBox.value = '';
        okCny('Imported');
      }catch(e){
        errCny('Import failed — invalid JSON');
      }
    });

    
    document.getElementById('cnyB_loadDefault').addEventListener('click', function(){
      if(!confirm('Load the full default CNY guide slides into this builder? This will overwrite your current draft in this browser.')) return;
      slides = fullDefaultSlides();
      idx = 0;
      rebuildSelect(slides, sel, idx);
      idx = renderSlide(slides, idx);
      saveDraft(slides);
      getJsonBox().value = exportJson(slides);
      okCny('Loaded default slides');
    });

document.getElementById('cnyB_clearAll').addEventListener('click', function(){
      if(!confirm('Clear all slides in this browser?')) return;
      slides = defaultSlides();
      idx = 0;
      rebuildSelect(slides, sel, idx);
      idx = renderSlide(slides, idx);
      saveDraft(slides);
      getJsonBox().value = '';
    });

    // auto-export on unload (optional)
    window.addEventListener('beforeunload', function(){
      try{ getCurrent(slides, idx); saveDraft(slides); }catch(e){}
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  }else{
    init();
  }
})();
